module.exports = __webpack_public_path__ + "static/brick_finance_customer_story_thumbnail-44aecb2eb1f601ed3807518ee0b09817.png";